/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- TRIVIA & POLLS - ANALYTICS PAGE : STYLES --------------- ++++++++++ */
export default {
    triviapollsanalyticspage: {
    }
};
